import axios from 'axios';

export const axiosConfigWithoutToken = axios.create({
  baseURL: 'https://monitor.inesco.energy/api'
  //baseURL: 'http://127.0.0.1:7087/api'
});

const axiosConfig = axios.create({
  baseURL: 'https://monitor.inesco.energy/api'
  //baseURL: 'http://127.0.0.1:7087/api'
});

axiosConfig.defaults.params = {};
axiosConfig.interceptors.request.use(
  (config) => {
    const tokenString = localStorage.getItem('token');
    const token = tokenString !== null ? tokenString : '';
    if (token) {
      config.params['authToken'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosConfig;
